// All markup and icons come from Rails. Client messages are always plain text.
export function toastStack() {
  let stack = document.getElementById("toast-stack")
  if (!stack) {
    stack = document.createElement("div")
    stack.id = "toast-stack"
    stack.className = "toast-stack"
    stack.dataset.controller = "toast-stack"
    stack.setAttribute("role", "region")
    stack.setAttribute("aria-label", "Notifications")
    stack.tabIndex = -1
    document.body.appendChild(stack)
  }
  return stack
}

export function showToast(message, { tone = "success", duration = 6000 } = {}) {
  if (!["success", "error", "info"].includes(tone)) tone = "info"
  const template = document.getElementById(`toast-template-${tone}`)
  if (!template) return null
  const toast = template.content.firstElementChild.cloneNode(true)
  toast.querySelector("[data-toast-message]").textContent = message
  toast.dataset.toastDurationValue = tone === "error" ? 0 : duration
  toastStack().prepend(toast)
  return toast
}
